import { observer } from 'mobx-react';
import { AspectRatio, Grid, GridItem } from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import ImageButton from '../../common/ImageButton';
import Beats from '../../assets/music_beats_low.imageset/music_beats_low.jpg';
import ElectronicDance from '../../assets/music_electronic_low.imageset/music_electronic__low.jpg';
import HipHop from '../../assets/music_hiphop_low.imageset/music_hiphop_low.jpg';
import Rock from '../../assets/music_rock_low.imageset/music_rock_low.jpg';
import Pop from '../../assets/music_pop_low.imageset/music_pop_low.jpg';
import Trap from '../../assets/music_trap_low.imageset/music_trap_low.jpg';
import RnBSoul from '../../assets/music_rnb_low.imageset/music_rnb_low.jpg';
import Other from '../../assets/music_dj_low.imageset/music_dj_low.jpg';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { MusicType } from '../../store/musicStore';
import { trackOnboardingCollectedMusic } from '../../utils/analytics';

export type MusicOptionType = {
  title: string;
  value: MusicType;
  image: string;
};

const CollectMusic = observer(() => {
  const { musicStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const musicOptions: MusicOptionType[] = [
    {
      title: 'Electronic & Dance',
      value: 'electronicDance',
      image: ElectronicDance,
    },
    { title: 'Hip Hop', value: 'hipHop', image: HipHop },
    { title: 'Rock', value: 'rock', image: Rock },
    { title: 'Pop', value: 'pop', image: Pop },
    { title: 'Trap', value: 'trap', image: Trap },
    { title: 'Beats', value: 'beats', image: Beats },
    { title: 'RnB & Soul', value: 'rnbSoul', image: RnBSoul },
    { title: 'Other', value: 'other', image: Other },
  ];

  const handleClick = (selectedMusic: MusicType) => {
    musicStore.toggleMusic(selectedMusic);
  };

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedMusic(Array.from(musicStore.selelctedMusic));
    navigate(getNextPagePath('CollectMusic'));
  };
  return (
    <Container>
      <ProgressBar currentPage="CollectMusic" />
      <PageHeader title="What kind of music gets you pumped?"></PageHeader>
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={8}
        margin={'5'}
        overflow={'auto'}
      >
        {musicOptions.map((option, idx) => (
          <AspectRatio ratio={1} key={idx}>
            <GridItem>
              <ImageButton
                title={option.title}
                imageSrc={option.image}
                onClick={() => handleClick(option.value)}
                isSelected={musicStore.selelctedMusic.has(option.value)}
              />
            </GridItem>
          </AspectRatio>
        ))}
      </Grid>
      <BottomSpacer />
      <ContinueButton
        isDisabled={musicStore.selelctedMusic.size < 1}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectMusic;
